import { computed, defineComponent, onUpdated } from 'vue';
import { useStore } from 'vuex';
import { useDateFormat } from '@/composables/dateFormat';
import { CabinetGetter } from '@/store/cabinet/cabinet.module';
import { Cabinet } from '@/store/cabinet/cabinet.model';
import { CabinetMinisterGetter } from '@/store/cabinetMinister/cabinetMinister.module';
import { CabinetMinister } from '@/store/cabinetMinister/cabinetMinister.model';
import LoadingComponent from '@/components/loading/Loading.vue';
import CabinetMinisterListComponent from './cabinetMinisterList/CabinetMinisterList.vue';

export default defineComponent({
  name: 'CabinetDetailComponent',
  components: {
    LoadingComponent,
    CabinetMinisterListComponent,
  },
  emits: [
    'toggle',
    'show'
  ],
  props: {
    cabinetId: {
      type: Number,
    },
  },
  setup: (props, context) => {
    const store = useStore();
    const dateFormat = useDateFormat();
    const isLoading = computed(() => store.getters[CabinetGetter.STATUS] === 'init' || store.getters[CabinetGetter.STATUS] === 'loading');
    const cabinet = computed<Cabinet | undefined>(() => store.getters[CabinetGetter.BY_ID](props.cabinetId));
    const cabinetMinisters = computed<CabinetMinister[]>(() => store.getters[CabinetMinisterGetter.ALL]);

    onUpdated(() => {
      if (!cabinet.value) {
        context.emit('toggle', null);
      }
    });

    const backClick = () => {
      context.emit('toggle', null);
    };

    const editClick = () => {
      context.emit('show', cabinet.value?.id);
    };

    const thaiDate = (date: Date) => dateFormat.toThaiDate(date, 'long');
    const statusHtml = (status: number) =>
      (status < 0)
        ? '<span class="text-danger">สิ้นสุดแล้ว</span>'
        : '<span class="text-success">กำลังใช้งาน</span>';

    return {
      cabinet,
      cabinetMinisters,
      isLoading,
      backClick,
      editClick,
      thaiDate,
      statusHtml,
    };
  },
});
